import { Controller } from "@hotwired/stimulus"

// Shows/hides ST and LA level dropdowns + "Gotowy zejść 1 klasę w dół" based on selected dance styles (ballroom_international only)
export default class extends Controller {
  static targets = ["levelStSection", "levelLaSection", "levelDownSection"]
  static values = {
    stStyleId: String,
    laStyleId: String
  }

  connect() {
    this._boundUpdate = this._updateVisibility.bind(this)
    const form = this.element.closest("form")
    if (form) {
      form.addEventListener("change", this._boundUpdate)
      this._updateVisibility()
    }
  }

  disconnect() {
    const form = this.element.closest("form")
    if (form) form.removeEventListener("change", this._boundUpdate)
  }

  _updateVisibility() {
    const selected = this._getSelectedStyleIds()
    const stId = this.stStyleIdValue
    const laId = this.laStyleIdValue
    const hasStOrLa = (stId && selected.includes(stId)) || (laId && selected.includes(laId))

    if (this.hasLevelStSectionTarget) {
      this.levelStSectionTarget.classList.toggle("d-none", !stId || !selected.includes(stId))
    }
    if (this.hasLevelLaSectionTarget) {
      this.levelLaSectionTarget.classList.toggle("d-none", !laId || !selected.includes(laId))
    }
    if (this.hasLevelDownSectionTarget) {
      this.levelDownSectionTarget.classList.toggle("d-none", !hasStOrLa)
    }
  }

  _getSelectedStyleIds() {
    const form = this.element.closest("form")
    if (!form) return []
    const inputs = form.querySelectorAll('input[name="partner_announcement[dance_style_ids][]"]:checked')
    return Array.from(inputs).map(inp => inp.value)
  }
}
